// extracted by mini-css-extract-plugin
module.exports = {"vipCustomer":"vipCustomer_vipCustomer_1cuq2","window":"vipCustomer_window_Ya_T5"};